module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17IpaAS/tc-custom/9781488007156.jpg?1720019854944",
      "alt": "This image is the cover for the book Firefighter Daddy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Firefighter Daddy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From Bachelor to Father"), _c('br'), _c('br'), _vm._v("Firefighter Liam McGregory is used to staring down fivealarm firesbut becoming a father to his two little nieces has him sending out a call for help. When the girls return a lost pup to its beautiful owner, Liam thinks widow Sarah Blackburn is just the person he needsor who the children need. "), _c('i', [_vm._v("He's")]), _vm._v(" promised to never marry again. ' Sarah takes his deal: she'll watch his kids and he'll watch her menagerie of petsbut the new father is off-limits. But two determined little matchmakers can be hard to resist when they need a mom to make one big happy family")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Daley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn’t traveling, she’s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0